import styled from 'styled-components';

export const Text = styled.div<{maxWidth?: string}>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: ${props => props.maxWidth ? props.maxWidth : '100%'};
  width: 100%;
`;

export const SubCategory = styled.div`
  font-size: 16px;
  color: #000;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const topSectionHeight = 32;
export const TopSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${topSectionHeight}px;
`;

export const TableContainer = styled.div`
  position: relative;
  padding-top: 10px;
  overflow: scroll;
  width: 100%;
  height: calc(100% - ${topSectionHeight}px);
  z-index: 1;

  .disabled-row td > div {
    opacity: 0.4;
  }

  .disabled-row td > .operations {
    opacity: 1;
  }
`;